import { render, staticRenderFns } from "./PostulacionIndex.vue?vue&type=template&id=63f13b78"
import script from "./PostulacionIndex.vue?vue&type=script&lang=js"
export * from "./PostulacionIndex.vue?vue&type=script&lang=js"
import style0 from "./PostulacionIndex.vue?vue&type=style&index=0&id=63f13b78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports